import { Component } from '@angular/core';
import { SimpleGalleryService } from '../../simple-gallery.service';
import { GALLERY_MEDIA_TYPE } from '../../core/simple-gallery.model';

@Component({
  selector: 'simple-viewer-image-modal',
  templateUrl: './simple-viewer-image-modal.component.html',
  styleUrl: './simple-viewer-image-modal.component.scss',
  standalone: false,
})
export class SimpleViewerImageModalComponent {
  GALLERY_MEDIA_TYPE = GALLERY_MEDIA_TYPE;
  mainContent$ = this.galleryService.getContent();

  constructor(private galleryService: SimpleGalleryService) {}
}
